/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken';
import {
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken';
import type { FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType } from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType';
import {
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSONTyped,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSON,
    FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSONTyped,
} from './FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType';
import type { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLogin } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLogin';
import {
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLogin';
import type { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLogin } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLogin';
import {
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLoginFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLoginFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLoginToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLoginToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLogin';
import type { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLogin } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLogin';
import {
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLoginFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLoginFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLoginToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLoginToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLogin';
import type { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLogin } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLogin';
import {
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLoginFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLoginFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLoginToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLoginToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLogin';
import type { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthData } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthData';
import {
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthDataFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthDataFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthDataToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthDataToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthData';
import type { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLogin } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLogin';
import {
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLoginFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLoginFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLoginToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLoginToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLogin';
import type { FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLogin } from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLogin';
import {
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLoginFromJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLoginFromJSONTyped,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLoginToJSON,
    FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLoginToJSONTyped,
} from './FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLogin';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
 */
export interface FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    /**
     * 
     * @type {FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    AuthenticationType: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationType;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    Game: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    Locale?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    SessionId?: string | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    SteamLogin?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLogin | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    SteamOpenIdLogin?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLogin | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    EgsLogin?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLogin | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    GoogleLogin?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLogin | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    FacebookLogin?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLogin | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    AuthenticateWithExternalIdGameAccessToken?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessToken | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthData}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    AwAuthData?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthData | null;
    /**
     * 
     * @type {FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLogin}
     * @memberof FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest
     */
    VkIdLogin?: FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLogin | null;
}



/**
 * Check if a given object implements the FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest interface.
 */
export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest(value: object): value is FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    if (!('AuthenticationType' in value) || value['AuthenticationType'] === undefined) return false;
    if (!('Game' in value) || value['Game'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'AuthenticationType': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeFromJSON(json['AuthenticationType']),
        'Game': json['Game'],
        'Locale': json['Locale'] == null ? undefined : json['Locale'],
        'SessionId': json['SessionId'] == null ? undefined : json['SessionId'],
        'SteamLogin': json['SteamLogin'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLoginFromJSON(json['SteamLogin']),
        'SteamOpenIdLogin': json['SteamOpenIdLogin'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLoginFromJSON(json['SteamOpenIdLogin']),
        'EgsLogin': json['EgsLogin'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginFromJSON(json['EgsLogin']),
        'GoogleLogin': json['GoogleLogin'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLoginFromJSON(json['GoogleLogin']),
        'FacebookLogin': json['FacebookLogin'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLoginFromJSON(json['FacebookLogin']),
        'AuthenticateWithExternalIdGameAccessToken': json['AuthenticateWithExternalIdGameAccessToken'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenFromJSON(json['AuthenticateWithExternalIdGameAccessToken']),
        'AwAuthData': json['AwAuthData'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthDataFromJSON(json['AwAuthData']),
        'VkIdLogin': json['VkIdLogin'] == null ? undefined : FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLoginFromJSON(json['VkIdLogin']),
    };
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequestToJSONTyped(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AuthenticationType': FxIdApplicationHandlersAuthAuthenticateToFxIdFxIdAuthenticationTypeToJSON(value['AuthenticationType']),
        'Game': value['Game'],
        'Locale': value['Locale'],
        'SessionId': value['SessionId'],
        'SteamLogin': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamLoginToJSON(value['SteamLogin']),
        'SteamOpenIdLogin': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestSteamOpenIdLoginToJSON(value['SteamOpenIdLogin']),
        'EgsLogin': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestEgsLoginToJSON(value['EgsLogin']),
        'GoogleLogin': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestGoogleLoginToJSON(value['GoogleLogin']),
        'FacebookLogin': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestFacebookLoginToJSON(value['FacebookLogin']),
        'AuthenticateWithExternalIdGameAccessToken': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAuthenticateWithExternalIdGameAccessTokenToJSON(value['AuthenticateWithExternalIdGameAccessToken']),
        'AwAuthData': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestAwAuthDataToJSON(value['AwAuthData']),
        'VkIdLogin': FxIdWebFeaturesAuthAuthenticateToFxIdAdapterForExternalIdAuthenticationRequestVkIdLoginToJSON(value['VkIdLogin']),
    };
}

